export const mockProduct = {
  id: 7353890078879,
  title: 'Hat',
  handle: 'hat',
  description: 'This hat is the best',
  published_at: '2022-04-04T09:12:10-07:00',
  created_at: '2022-04-04T09:12:09-07:00',
  vendor: 'kevdevkev',
  type: '',
  tags: ['drop'],
  price: 10000,
  price_min: 10000,
  price_max: 10000,
  available: true,
  price_varies: false,
  compare_at_price: null,
  compare_at_price_min: 0,
  compare_at_price_max: 0,
  compare_at_price_varies: false,
  variants: [
    {
      id: 42053137268895,
      title: 'Default Title',
      option1: 'Default Title',
      option2: null,
      option3: null,
      sku: '',
      requires_shipping: true,
      taxable: true,
      featured_image: null,
      available: true,
      name: 'Hat',
      public_title: null,
      options: ['Default Title'],
      price: 10000,
      weight: 0,
      compare_at_price: null,
      inventory_management: 'shopify',
      barcode: ''
    }
  ],
  images: ['//cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731'],
  featured_image:
    '//cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731',
  options: [{ name: 'Title', position: 1, values: ['Default Title'] }],
  url: '/products/hat',
  media: [
    {
      alt: null,
      id: 25110794862751,
      position: 1,
      preview_image: {
        aspect_ratio: 1.0,
        height: 612,
        width: 612,
        src: 'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731'
      },
      aspect_ratio: 1.0,
      height: 612,
      media_type: 'image',
      src: 'https://cdn.shopify.com/s/files/1/0604/6085/9551/products/blankblackhat.jpg?v=1649088731',
      width: 612
    }
  ]
};
